import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=49e7452d"
import script from "./TabView.vue?vue&type=script&lang=js"
export * from "./TabView.vue?vue&type=script&lang=js"
import style0 from "./TabView.vue?vue&type=style&index=0&id=49e7452d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports